export interface IUserCredentials {
  email: string;
  password: string;
}

export interface IUserName {
  firstname: string;
  lastname: string;
}

export interface IRegisterCredentials extends IUserCredentials, IUserName {}

export interface IVerifyCredentials {
  email: string;
  code: string;
}

export interface IChangePassword {
  oldPassword?: string;
  newPassword: string;
}

export interface IResetPassword {
  email: string;
  code: string;
  password: string;
}

export enum CognitoErrorCodes {
  UsernameExistsException = "UsernameExistsException",
  UserNotConfirmedException = "UserNotConfirmedException",
  NotAuthorizedException = "NotAuthorizedException",
  ExpiredCodeException = "ExpiredCodeException",
  UserNotFoundException = "UserNotFoundException",
  InvalidParameterException = "InvalidParameterException",
  LimitExceededException = "LimitExceededException",
}

export const AUTH_ACTIONS_PREFIX = "auth";

export const AUTH_ACTIONS = {
  login: `${AUTH_ACTIONS_PREFIX}/login`,
  logout: `${AUTH_ACTIONS_PREFIX}/logout`,
  register: `${AUTH_ACTIONS_PREFIX}/register`,
  verifyAccount: `${AUTH_ACTIONS_PREFIX}/verifyAccount`,
  deleteAccount: `${AUTH_ACTIONS_PREFIX}/deleteAccount`,
  confirmEmail: `${AUTH_ACTIONS_PREFIX}/confirmEmail`,
  requestChangeEmail: `${AUTH_ACTIONS_PREFIX}/requestChangeEmail`,
  changePassword: `${AUTH_ACTIONS_PREFIX}/changePassword`,
  resetPassword: `${AUTH_ACTIONS_PREFIX}/resetPassword`,
  requestResetPassword: `${AUTH_ACTIONS_PREFIX}/requestResetPassword`,
  // user
  getCurrentUser: `${AUTH_ACTIONS_PREFIX}/getCurrentUser`,
  getCurrentInternalUser: `${AUTH_ACTIONS_PREFIX}/getCurrentInternalUser`,
  editCurrentUser: `${AUTH_ACTIONS_PREFIX}/editCurrentUser`,
  editUser: `${AUTH_ACTIONS_PREFIX}/editUser`,
};

export type IAuthActions = typeof AUTH_ACTIONS[keyof typeof AUTH_ACTIONS];
